import { complianceFixForTitle, normalTitle } from '@bartizo/shared';

/**
 * The few fixes the runbook makes live (P11.18). Every other remediation stays a
 * comment: a benchmark gives prose, differs per check, and much of it (the
 * firewall, mounts, SSH, the bootloader) can lock a server out or stop a
 * service, which no script written without seeing the server should do.
 *
 * The fixes themselves are `COMPLIANCE_FIXES` in `@bartizo/shared`, so the script
 * a person takes to a server and the root helper's `apply_compliance_fixes` run
 * the same commands. Matched by the benchmark's own title, which CIS keeps the
 * same across Ubuntu releases, so one entry serves every policy that has the check.
 */

export interface SafeFix {
  /** What it does, in a line, for the person reading the script. */
  does: string;
  /** Run by `bash -c` as root, in order; every command is safe to repeat. */
  commands: string;
}

export { normalTitle };

export const safeFixFor = (title: string): SafeFix | undefined => complianceFixForTitle(title);

/** How many of these titles the script can fix by itself. */
export const safeFixCount = (titles: readonly string[]): number =>
  titles.filter((title) => safeFixFor(title) !== undefined).length;
